let state = []

const mutations = {
  /** 批量添加editor */
  batchAddEditor(state, list) {
    list &&
      list.forEach(item => {
        state.push(item)
      })
  },
  /** 添加editor */
  addEditor(state, obj) {
    if (obj) {
      state.push(obj)
    }
  },
  /**
   * 修改editor
   * obj.index 要修改的序号
   *  */
  updateEditor(state, obj) {
    if (obj) {
      state.forEach((item, index) => {
        if (obj.index === index) {
          delete item.uid
          item.value = obj.value
        }
      })
    }
  },
  /** 删除editor条目 */
  removeEditorItem(state, index) {
    if (index >= 0) {
      state.splice(index, 1)
    }
  },
  /** editor条目 下移一个单位 */
  downEditorItem(state, index) {
    if (index >= 0) {
      state.splice(index + 2, 0, state[index])
      state.splice(index, 1)
    }
  },
  /** editor条目 上移一个单位 */
  upEditorItem(state, index) {
    if (index >= 0) {
      state.splice(index - 1, 0, state[index])
      state.splice(index + 1, 1)
    }
  },
  /** 删除editor */
  clearEditor(state) {
    state.length = 0
  }
}

const actions = {
  addEditor: ({ commit }, obj) => {
    commit('addEditor', obj)
  },

  batchAddEditor: ({ commit }, list) => {
    commit('batchAddEditor', list)
  },

  updateEditor: ({ commit }, obj) => {
    commit('updateEditor', obj)
  },

  removeEditorItem: ({ commit }, index) => {
    commit('removeEditorItem', index)
  },

  downEditorItem: ({ commit }, index) => {
    commit('downEditorItem', index)
  },

  upEditorItem: ({ commit }, index) => {
    commit('upEditorItem', index)
  },

  clearEditor: ({ commit }) => {
    commit('clearEditor')
  }
}
export default {
  state,
  actions,
  mutations
}
